import { Input } from 'antd';
import styled from 'styled-components';

export const StyledTextArea = styled(Input.TextArea)`
    font-size: 1.4rem;
    line-height: 2.2rem;
`;
